<template>
  <div class="modal">
    <div class="mask"></div>
    <div :class="fit ? 'fit-content contenido-modal' : 'contenido-modal'">
      <div v-if="showMovilHeader" class="movil-header">
        <button @click="closeModal" type="button" class="btn-close"></button>
      </div>
      <div v-if="showHeader" class="modal-header">
        <span>{{ header }}</span>
        <button @click="closeModal" type="button" class="btn-close">X</button>
      </div>
      <div :class="cuerpoModal" class="cuerpo-modal">
        <div>
          <div class="detalleOrden">
            <div class="orden-header-container">
              <span class="noOrden"><b>Orden:</b> {{orden.order}}</span>
              <div class="orden-header-body">
                <span><b>Fecha ingreso:</b> {{dateFormat(orden.received_at || new Date())}}</span>
                <span><b>Fecha promesa:</b> {{dateFormat(orden.promise_date || new Date())}}</span>
              </div>
            </div>
            <section class="detalle-orden-container">
              <div class="detalle-cliente-container">
                <h3>Datos del cliente:</h3>
                <div class="group-container">
                  <label for="">Nombre:</label>
                  <span>{{orden.cliente}}</span>
                </div>
                <div class="group-container">
                  <label for="">Email:</label>
                  <span>{{orden.client?.email}}</span>
                </div>
                <div class="group-container">
                  <label for="">Teléfono:</label>
                  <span>{{orden.client?.telephones[0]}}</span>
                </div>
              </div>
              <div class="detalle-vehiculo-container">
                <h3>Datos del vehículo:</h3>
                <div class="detalle-vehiculo-body">
                  <div class="detalle-group">
                    <div class="group-container">
                      <label for="">Marca:</label>
                      <span>{{orden.vehicle?.model?.brand?.name || 'NA'}}</span>
                    </div>
                    <div class="group-container">
                      <label for="">Modelo:</label>
                      <span>{{orden.vehicle?.model?.name || 'NA'}}</span>
                    </div>
                    <div class="group-container">
                      <label for="">Año:</label>
                      <span>{{orden.vehicle?.year || 'NA'}}</span>
                    </div>
                    <div class="group-container">
                      <label for="">Color:</label>
                      <span>{{orden.vehicle?.colour || 'NA'}}</span>
                    </div>
                  </div>
                  <div class="detalle-group">
                    <div class="group-container">
                      <label for="">Placas:</label>
                      <span> {{orden.vehicle?.license_plate || 'NA'}}</span>
                    </div>
                    <div class="group-container">
                      <label for="">No de cilindros:</label>
                      <span>{{orden.vehicle?.cylenders || 'NA'}}</span>
                    </div>
                    <div class="group-container">
                      <label for="">No de serie:</label>
                      <span>{{orden.vehicle?.serial_number || 'NA'}}</span>
                    </div>
                    <div class="group-container">
                      <label for="">Kilometraje:</label>
                      <span>{{numberFormat(orden.vehicle?.mileage || 'NA')}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section class="servicios-orden-container">
              <h3>Servicios solicitados:</h3>
                <ul class="servicios-orden-content" v-for="(service, index) in orden.services" :key="index">
                  <li class="group-container">
                    <label for="">Mecanico:</label>
                    <span>{{`${service.mechanics[0]?.name} ${service.mechanics[0]?.first_lastname} ${service.mechanics[0]?.second_lastname}`}}</span>
                  </li>
                  <li class="group-container">
                    <label for="">Servicio:</label>
                    <span>{{service.service?.name || 'NA'}}</span>
                  </li>
                </ul>
            </section>
            <section class="detalle-servicio-container">
              <h3>Detalles del servicio:</h3>
              <div class="detalle-servicio-body">
                <div class="detalle-servicio">
                  <div class="group-container">
                    <!-- <label for="">Detalle de servicio:</label> -->
                    <ul>
                      <li v-for="(service, index) in orden.services" :key="index">
                        {{ service.detail }}
                      </li>
                      <li>
                        {{orden.detail}}
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- <div class="detalle-general">
                  <div class="group-container">
                    <label for="">Detalle general:</label>
                    <span>{{orden.detail}}</span>
                  </div>
                </div> -->
              </div>
            </section>
            <span class="detalle-saldo"><b>Saldo a favor:</b> {{moneyFormat(orden.saldo_favor || 0)}}</span>
          </div>
          <div class="contratoAdhesion">
            <p>
              CONTRATO DE PRESTACIÓN DE SERVICIOS DE REPARACIÓN Y/O MANTENIMIENTO DE VEHÍCULO, QUE CELEBRAN, POR UNA PARTE, <b>PATRICIA CASTRO ESPINOZA</b> COMO <b>"EL PRESTADOR DE SERVICIO"</b> Y POR LA OTRA PARTE {{orden.cliente || 'NA'}} COMO <b>"EL CONSUMIDOR"</b> A QUIENES DE MANERA CONJUNTA SE LES DENOMINA COMO <b>"LAS PARTES"</b>. A TENOR DE LAS SIGUIENTES CLAUSULAS:
            </p>
            <h3>DECLARACIONES</h3>
            <section>
              <span class="titulo">1.- DECLARA "EL PRESTADOR DEL SERVICIO":</span>
              <ul>
                <li><b>a.</b> Es una persona física de nacionalidad mexicana y con suficiente capacidad legal para obligarse en los términos del presente Contrato.</li>
                <li><b>b.</b> Su domicilio se encuentra ubicado en Carlos M. Esquerro 2298 col. Libertad cp 80180 Culiacán, Sinaloa, el cual señala como domicilio convencional para todos los efectos legales del presente Contrato.</li>
                <li><b>c.</b> Se encuentra inscrita en el Registro Federal de Contribuyentes con la clave CAEP-860626-DV8</li>
                <li><b>d.</b> Cuenta con el número de registro SIEM</li>
                <li><b>e.</b> Cuenta con la Infraestructura, los elementos propios, los recursos técnicos y humanos suficientes para cumplir con sus obligaciones conforme a lo establecido en el presente Contrato.</li>
                <li><b>f.</b> Cumple con las licencias, permisos, avisos, certificados y autorizaciones previstas en las disposiciones legales y normas vigentes que corresponden.</li>
                <li><b>g.</b> Para la atención de dudas, aclaraciones, reclamaciones o para proporcionar servicios de orientación, señala el teléfono 6672585396 y correo electrónico automotrizrm@hotmail.com, con un horario de atención se 8:00 horas a 18:30 horas.</li>
                <li><b>h.</b> Indico a EL CONSUMIDOR el costo total de servicio objeto del presente Contrato.</li>
              </ul>
            </section>
            <section>
              <h3>II.- Declara “EL CONSUMIDOR”:</h3>
              <ul>
                <li><b>a.</b> Llamarse como ha quedado plasmado en el proemio de este Contrato y condiciones del presente Contrato, manifestando que cuenta con la capacidad legal para la celebración de este Contrato.</li>
                <li><b>b.</b> Su domicilio se encuentra ubicado en {{orden.client?.address || 'NA'}}, el cual señala como domicilio convencional para todos los efectos legales del presente Contrato.</li>
              </ul>
            </section>
            <p>En virtud de las declaraciones anteriores, “LAS PARTES” convienen en obligarse conforme las siguientes:</p>
            <h3>CLAUSULAS</h3>
            <section>
              <p><b>PRIMERA. CONSENTIMIENTO. –</b> LAS PARTES de común acuerdo manifiestan su voluntad para celebrar el presente Contrato cuya naturaleza jurídica es la reparación y/o mantenimiento de vehículo.</p>
              <p><b>SEGUND. OBJETO. –</b> El objeto del Presente contrato es que EL PRESTADOR DEL SERVICIO realizará las operaciones y composturas descritas en el anverso del presente Contrato, solicitas por EL CONSUMIDOR previo pago de un precio cierto y determinado y a las que se someterá el vehículo para obtener condiciones del funcionamiento de acuerdo al estado de éste. Asimismo, EL PRESTADOR DEL SERVICIO no condicionará la prestación del servicio de reparación y/o el mantenimiento del vehículo a la adquisición o renta de otros productos o servicios en el establecimiento o en otro taller o agencia.</p>
              <p>
                <b>TERCERA, COSTO DEL SERVICIO. –</b> El precio del servicio contratado se establece en el presupuesto que forma parte del presente Contrato. EL CONSUMIDOR al momento de celebrar al presente Contrato deberá realizar el primer pago por concepto de anticipo y el resto en la fecha de entrega del vehículo, dichas cantidades se indican en el anverso del presente Contrato. Todo pago efectuado por EL CONSUMIDOR deberá realizarse en tarjeta de débito, tarjeta de crédito, transferencia bancaria o en cheque, en moneda nacional, sin menoscabado de poderlo hacer en moneda extranjera al tipo de cambio publicado en el diario oficial de la Federación al día en el pago se efectúe.
                <br>
                <br>
                En caso de que EL CONSUMIDOR realice el pago en cheque y no se cubra el pago por causas imputables al librador, EL PRESTADOR DEL SERVICIO se reserva el derecho de realizar el cobro adicional del 20% del valor del documento, por concepto de daños y perjuicios, conforme al artículo 193 de la Ley General de Títulos y Operaciones de Crédito.
                <br>
                <br>
                En cualquier caso, EL PRESTADOR DEL SERVICIO se obliga a omitir y entregar AL CONSUMIDOR la factura correspondiente o documento fiscal que ampare los cobros realizados por la prestación del Servicio proporcionado conforme a la legislación correspondiente.
                <br>
                <br>
                EL PRESTADOR DEL SERVICIO pondrá a disposición de EL CONSUMIDOR los precios de los servicios, mano de obra, refacciones y materiales a usar en las reparaciones ofrecidas. Asimismo, previo a la realización del servicio EL PRESTADOR DEL SERVICIO presentará a EL CONSUMIDOR el presupuesto. Una vez aprobado el presupuesto por EL CONSUMIDOR, EL PRESTADOR DE SERVICIO procederá a efectuar el servicio solicitado. Los incrementos que resulten durante la reparación por costos no previsibles deberán ser autorizados por EL CONSUMIDOR, en forma escrita, siempre y cuando estos excedan al 205 del presupuesto. Si el incremento citado es inferior lo podrán autorizar telefónicamente. El tiempo, que, en su caso, transcurra para requisitar esta condición se modificará la fecha de entrega, en la misma proporción.
                <br>
                <br>
                El importe señala en el Presupuesto, contempla todas las cantidades y conceptos referentes al objeto del presente Contrato; por lo que EL PRESTADOR DE SERVICIO se obliga a respetar en todo momento dicho costo sin poder cobrar otra cantidad no estipulada en el presente Contrato, deberá ser autorizado por EL CONSUMIDOR.
              </p>
              <p><b>CUARTA. ENTRGA DEL VEHÍCULO. –</b> La entrega del vehículo será en la fecha contemplada en el anverso del presente Contrato. Para el caso de que EL CONSUMIDOR, sea el que proporcione las refacciones la fecha de entrega será {{dateFormat(orden.promise_date || new Date())}}.</p>
              <p><b>QUINTA. REFACCIONES Y PARTES PARA LA PRESTACIÓN DEL SERVICIO. –</b> EL PRESTADOR DEL SERVICIO exclusivamente utilizará para los servicios de este Contrato, partes, refacciones u otros materiales nuevos y apropiados para el vehículo, salvo que EL CONSUMIDOR autorice expresamente que se usen otras, si EL PRESTADOR DEL SERVICIO autoriza, EL CONSUMIDOR suministrará las partes, refacciones o materiales necesarios para la reparación y/o mantenimiento del vehículo. En ambos casos, la autorización respectiva se hará constar en el anverso del presente contrato.</p>
              <p>
                <b>SEXTA. ENTREGA DE LAS PARTES O REFACCIONES. –</b> EL PRESTADOR DEL SERVICIO hará entrega de las refacciones, partes o piezas sustituidas en la reparación y/o mantenimiento del vehículo al momento de la entrega de éste, salvo en los siguientes casos:
                <ul>
                  <li><b>a.</b> Cuando EL CONSUMIDOR, exprese lo contrario.</li>
                  <li><b>b.</b> Las partes, refacciones o piezas sean cambiadas en uso de garantía.</li>
                  <li><b>c.</b> Se trate de residuos considerados peligrosos de acuerdo con las disposiciones legales aplicables.</li>
                </ul>
              </p>
              <p>
                <b>SÉPTIMA. OBLIGACIONES DE LAS PARTES. –</b>
                <br>
                EL PRESTADOR DEL SERVICIO SE OBLIGA A:
                <ul>
                  <li><b>a.</b> Cumplir con lo establecido en el presente contrato.</li>
                  <li><b>b.</b> Entregar a EL CONSUMIDOR las refacciones o partes del vehículo que haya cambiado a la entrega del vehículo.</li>
                  <li><b>c.</b> Entregar el vehículo en las fechas establecidas por el presente Contrato.</li>
                  <li><b>d.</b> Proporcionar la información necesaria que sea solicitado por EL CONSUMIDOR, en la relación con el presente Contrato.</li>
                  <li><b>e.</b> Cumplir ante cualquier percance en caso de subcontratar los servicios.</li>
                </ul>
                EL CONSUMIDOR SE OBLIGA A:
                <ul>
                  <li><b>a.</b> Cumplir con lo establecido en el presente Contrato.</li>
                  <li><b>b.</b> Proporcionar a EL PRESTADOR DEL SERVICIO el vehículo en la fecha y horario establecido en el presente Contrato.</li>
                  <li><b>c.</b> Entregar a EL PRESTADOR DEK SERVICIO las refacciones o partes que le haya solicitado este último.</li>
                  <li><b>d.</b> Recoger el vehículo en la fecha y hora establecida en este contrato.</li>
                  <li><b>e.</b> En caso de que el servicio sea prestado en el domicilio indicado por EL CONSUMIDOR, deberá permitir el paso previa identificación de EL PRESTADOR DEL SERVICIO.</li>
                  <li><b>f.</b> Hacer los pagos correspondientes establecidos en este Contrato a tiempo.</li>
                </ul>
              </p>
              <p>
                <b>OCTAVA. GARANTÍA DE LA PRESTACIÓN DEL SERVICIO. –</b> Las reparaciones a que se refiere el presupuesto aceptado por EL CONSUMIDOR, tiene una garantía de 90 días contados a partir de la fecha de entrega del vehículo ya reparado en mano de obra y en refacciones la especificada por el fabricante, siempre y cuando no se manifieste mal uso, negligencia o descuido.
                <br>
                <br>
                Si el vehículo es intervenido por un tercero, EL PRESTADOR DEL SERVICIO no será responsable y la garantía quedará sin efecto. Las reclamaciones por garantía se harán en el establecimiento de EL PRESTADOR DEL SERVICIO, para lo cual, EL CONSUMIDOR, deberá presentar su vehículo en dicho establecimiento.
                <br>
                <br>
                Las reparaciones efectuadas por EL PRESTADOR DEL SERVICIO en cumplimiento a la garantía serán sin cargo alguno para EL CONSUMIDOR, salvo aquellos trabajos que no deriven de las reparaciones aceptadas en el presupuesto. No se computará dentro del plazo de garantía, el tiempo que dure la reparación y/o el mantenimiento del vehículo para el cumplimiento de la misma, los gastos en que incurra EL CONSUMIDOR para hacer válida la garantía en un domicilio diverso al DEL PRESTADOR DEL SERVICIO, deberán ser cubiertos por éste.
              </p>
              <p><b>NOVENA. PRUEBAS DEL VAHÍCULO. –</b> EL CONSUMIDOR, autoriza el uso del vehículo en zonas aledañas con un radio de 5kilómetros al área del establecimiento, a efecto de pruebas o verificación de las reparaciones a efectuar o efectuadas.</p>
              <p><b>DÉCIMA. RESPONSABILIDAD POR DAÑOS AL VEHÍCULO. –</b> EL PRESTADOR DEL SERVICIO se hace responsable por los daños causados al vehículo de EL CONSUMIDOR, como consecuencia de los recorridos de prueba por parte del personal DE EL PRESTADOR DEL SERVICIO. El riesgo de un recorrido de prueba, es por cuenta de EL CONSUMIDOR, cuando él mismo solicite que será él o un representante suyo quien guíe el vehículo. Asimismo, EL PRESTADOR DEL SERVICIO se hace responsable por las descomposturas, daños, pérdidas parciales o totales, imputables a él o a sus empleados, que sufra el vehículo, el equipo y aditamentos que EL CONSUMIDOR haya notificado al momento de la recepción del vehículo, mientras se encuentren bajo su responsabilidad para llevar a cabo la reparación y/o el mantenimiento solicitado, así como para hacer efectiva la garantía otorgada.</p>
              <p>
                <b>DÉCIMA PRIMERA. CAUSAS DE RESCICIÓN. –</b> Son causas de rescisión:
                <ul>
                  <li> Que alguna de LAS PARTES no cumpla con lo estipulado en el presente Contrato.</li>
                  <li> Si el Servicio no corresponde con lo pactado y/o solicitado por EL CONSUMIDOR.</li>
                </ul>
                En caso de recisión del presente Contrato, la parte que incumpla deberá pagar lo correspondiente a la pena convencional.
              </p>
              <p>
                <b>DÉCIMA SEGUNDA. PENA CONVENCIONAL. –</b> Se establece como pena convencional por el incumplimiento de cualquiera de LAS PARTES a las obligaciones contraídas por el presente contrato, el 15% del precio total de la Prestación del Servicio de reparación o mantenimiento del vehículo sin incluir el Impuesto del Valor Agregado (IVA).
                <br>
                <br>
                Esta sanción se estipula por el simple retraso en el cumplimiento de las obligaciones y que la prestación del servicio no sea prestado a lo establecido en el presente Contrato, sin perjuicio del derecho que tiene LAS PARTES de optar entre exigir el cumplimiento del Contrato o rescindirlo.
                <br>
                <br>
                LAS PARTES en caso de que requieran el pago de la Pena Convencional por cualquiera de los supuestos señalas en la Cláusula Décima, deberán de solicitar por escrito en el domicilio de la parte que incumplió, el pago de dichas penas, debiendo hacer el pago la parte que incumplió en los cinco días hábiles siguiendo de haber recibido dicha solicitud.
              </p>
              <p><b>DÉCIMA TERCERA. ENTREGA DEL VEHÍCULO. –</b> En caso de que el vehículo no sea recogido por EL CINSUMIDOR en un plazo de 48 horas a partir de la fecha señalada para la entrega, pagará como concepto de depósito un salario mínimo vigente en el lugar que se celebre en presente Contrato, por cada 24 horas que transcurran.</p>
              <p><b>DÉCIMA CUARTA. CANCELACIÓN DEL CONTRATO. –</b> EL CONSUMIDOR cuenta con plazo de 5 días hábiles posteriores a la firma del presente Contrato para cancelar la operación si responsabilidad y penalización alguna de su parte, en cuyo caso EL PRESTADOR DEL SERVICIO se obliga a reintegrar yodas las cantidades que EL CONSUMIDOR le haya entregado, en un plazo de 5 días naturales posteriores a la solicitud de cancelación. La cancelación aplica siempre y cuando EL PRESTADOR DEL SERVICIO no haya iniciado el Servicio objeto del presente Contrato. Las cancelaciones deberán solicitarse por escrito en el domicilio señalado en el presente Contrato o bien por correo registrado o certificado, tomando como fecha de revocación la de recepción para su envío.</p>
              <p><b>DÉCIMA QUINTA. SUBCONTRATACIÓN. –</b> En caso de que EL PRESTADOR DEL SERVICIO desee subcontratar la prestación del Servicio, deberá hacerlo del conocimiento a EL CONSUMIDOR al momento de la firma del presente Contrato. Cualquier incumplimiento a lo establecido en el presente Contrato, EL PRESTADOR DEL SERVICIO responderá ante EL CONSUMIDOR por dicho incumplimiento.</p>
              <p><b>DÉCIMA SEXTA. PRESENTACIÓN DEL SERVICIO EN EL DOMICILIO DEL CONSUMIDOR. –</b> Cuando la presentación del Servicio se vaya a llevar acabo en el domicilio señalado por EL CONSUMIDOR, el personal de EL PRESTADOR DEL SERVICIO debe identificarse ante EL CONSUMIDOR, mediante la presentación del documento que l acredite para ´peste propósito. En caso de que dicho servicio tenga un costo, éste se indicará en el anverso del presente Contrato.</p>
              <p><b>DÉCIMA SÉPTIMA. NO RESPONSABILIDAD DE EL PRESTADOR DEL SERVICIO. –</b> EL CONSUMIDOR libera a EL PRESTADOR DEL SERVICIO de cualquier responsabilidad que hubiera surgido o pudiese surgir con relación al origen, propiedad, posesión, o cualquier otro derecho inherente al vehículo, partes o componentes del mismo.</p>
              <p><b>DÉCIMA OCTAVA. AVISO DE PRIVACIDAD. –</b> Previo a la firma del presente Contrato y cumplimiento a lo dispuesto en la Ley Federal de Protección de Datos Personales en posesión de Particulares, EL PRESTADOR DE SERVICIOS hizo del conocimiento a EL CONSUMIDOR del aviso de privacidad, el cual se encuentra en <a href="https://automotrizrm.com" target="_blank" rel="noopener noreferrer">https://automotrizrm.com</a>, así como del procedimiento para ejercer los derechos de acceso, rectificación, cancelación y oposición al tratamiento de sus datos personales (en adelante, derechos “ARCO”).</p>
              <p><b>DÉCIMA NOVENA. -</b> La Procaduría Federal del Consumidor es competente en la vía administrativa para resolver cualquier controversia que se suscite sobre la interpretación o cumplimiento del presente Contrato. Sin perjuicios de lo anterior, LAS PARTES se someten a la jurisdicción de los Tribunales competentes en Culiacán Sinaloa, renunciando expresamente a cualquier jurisdicción que pudiera corresponderles, por razón de sus domicilios presentes o futuros o por cualquier otra razón. Leído por LAS PARTES el contenido del presente Contrato y sabedoras de su alcance legal, lo firman por duplicado en la Ciudad de Culiacán a los {{getDay}} días del mes de {{getMonth}} del año {{getYear}}.</p>
            </section>
            <br>
            <br>
            <span><b>Autorización para la utilización de información con fines de mercadotécnicos o publicitarios</b></span>
            <p>EL CONSUMIDOR acepta que EL PRESTADOR DE EL SERVICIO ceda o trasmita a terceros, con fines mercadotécnicos o publicitarios, la información proporcionado por él con el motivo del presente Contrato acepta que EL PRESTADOR DE EL SERVICIO le envíe publicidad sobre bienes y servicios.</p>
            <br>
            <br>
          </div>
        </div>
        <div class="signature-container">
          <div class="signature-body">
            <div class="img-container">
              <img @click="openFirmaDigital(1)" :src="imagenEmpleado" alt="" />
            </div>
            <span>{{orden.employee?.name}} {{orden.employee?.first_lastname}} {{orden.employee?.second_lastname}}</span>
            <span>FIRMA DEL PRESTADOR DEL SERVICIO</span
            >
          </div>
          <div class="signature-body">
            <div class="img-container">
              <img @click="openFirmaDigital(2)" :src="imagenCliente" alt="" />
            </div>
            <span>{{orden.cliente}}</span>
            <span>FIRMA DEL CONSUMIDOR</span>
          </div>
        </div>
        <br>
        <br>
        <p class="contract-footer">Este contrato fue aprobado y registrado por la Procuraduría Federal del Consumidor bajo el número 12036-2018 de fecha 22 de noviembre de 2018. Cualquier variación de presente Contrato en perjuicio de EL CONSUMIDOR. Frente al contrato de adhesión registrado, se tendrá por no puesta.</p>
        <div class="msgError" v-if="messageError">
          <p>{{messageError}}</p>
        </div>
        <div class="button-container">
          <v-btn
            outlined
            large
            elevation="2"
            class="ml-1 my-2 my-md-0"
            @click="closeModal"
          >
            Cancelar
          </v-btn>
          <v-btn
            large
            color="info"
            elevation="2"
            class="ml-1 my-2 my-md-0"
            @click="guardar"
          >
            Guardar
          </v-btn>
        </div>
      </div>
      <div v-if="footer" class="modal-footer">
        <div class="modal-btn-container">
          <p @click="closeModal" class="btn-cierre">Cerrar</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrdenDigital",
  components: {},
  props: {
    header: {
      type: String,
      default: "Orden digital",
    },
    showMovilHeader: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    fit: {
      type: Boolean,
      default: false,
    },
    cuerpoModal: {
      type: String,
      default: "",
    },
    footer: {
      type: Boolean,
      default: false,
    },
    orden: {
      type: Object,
      default: () => {
        return {};
      },
    },
    imgEmpleado: {
      type: String,
      default: null,
    },
    imgCliente: {
      type: String,
      default: null,
    },
    serverError: {
      type: String,
      default: null
    }
  },
  emits: ["closeModal"],
  data() {
    return {
      imagenEmpleado: null,
      imagenCliente: null,
      currentDate: new Date(),
      messageError: null
    };
  },
  methods: {
    dateFormat(date) {
      const _date = new Date(date)
      return _date.toLocaleDateString('es-MX')
    },
    moneyFormat(amount) {
      const _amount = amount.toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN'
      })

      return _amount
    },
    numberFormat(number) {
      return new Intl.NumberFormat('es-MX').format(number)
    },
    closeModal() {
      this.$emit("closeModal");
    },
    openFirmaDigital(tipo) {
      this.$emit("abrirFirmaDigital", tipo);
    },
    guardar() {
      this.$emit('guardar')
    }
  },
  computed: {
    getDay() {
      return this.currentDate.getDate()
    },
    getMonth() {
      return this.currentDate.toLocaleString('default', { month: 'long' });
    },
    getYear() {
      return this.currentDate.getFullYear()
    }
  },
  watch: {
    imgEmpleado: {
      handler() {
        this.imagenEmpleado = this.imgEmpleado;
      },
      deep: true,
      immediate: true,
    },
    imgCliente: {
      handler() {
        this.imagenCliente = this.imgCliente;
      },
      deep: true,
      immediate: true,
    },
    serverError: {
      handler() {
        this.messageError = this.serverError
      }
    }
  },
};
</script>

<style scoped>
/* MODAL */
.solo {
  width: 179px;
  background-position-x: 40px;
  background-position-y: 8px;
  background-size: 18px;
}

.boton-cancelar:hover {
  color: #fff;
  background-color: #4873d3;
}

.modal-btn-container {
  display: flex;
  justify-content: flex-end;
}

.btn-cierre {
  font: normal normal bold 16px/22px Open Sans;
  color: #4caf50;
  padding-right: 26px;
  cursor: pointer;
}

.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);

  padding: 20px;
  padding-bottom: 10px;
  padding-top: 10px;
}

.movil-header {
  display: none;
}

.fit-content {
  height: min-content;
  min-width: 300px;
  min-height: min-content !important;
  max-width: fit-content !important;
}

.mask {
  background-color: transparent;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.contenido-modal {
  position: relative;
  background-color: #ffffff;
  margin: auto;
  border-radius: 10px;
  min-width: 320px;
  box-shadow: 0px 3px 6px #00000029;
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s;
  box-sizing: border-box;
  z-index: 1000;
  width: 100%;
  /* height: 100%; */
  max-width: 50vw;

  height: min-content;
  max-height: -webkit-fill-available;
  overflow: auto;
}
.modal-header {
  border-radius: 6px 6px 0 0;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 15px;
}
.modal-header span {
  flex: 1;
  font-weight: 600;
  text-align: left;
  font: normal normal bold 18px/27px Open Sans;
  letter-spacing: 0px;
  color: #4873d3;
  opacity: 1;
  margin-top: 10px;
  text-align: center;
  font-size: 25px;
}

.btn-close {
  font-size: 25px;
  font-weight: bold;
  color: #000;
  cursor: pointer;
}

.contenido-modal .close {
  display: flex;
  margin-left: auto;
  margin-right: 20px;
  margin-top: -10px;
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
}

.contenido-modal .close:hover {
  background-color: #f2f2f2;
  transition: 0.3s;
}
.contenido-modal .cuerpo-modal {
  overflow-y: auto;
  /* padding: 0px 26px; */

  padding: 15px 35px;
}
.contenido-modal .cuerpo-modal.overflow {
  overflow-y: visible;
  padding: 0px 26px;
}
.cuerpo-modal .contenedor-status {
  text-align: left;
  font: normal normal 600 14px/19px Open Sans;
  letter-spacing: 0px;
  opacity: 1;
}
.cuerpo-modal .contenedor-item {
  width: 100%;
  text-align: left;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font: normal normal normal 14px/19px Open Sans;
}
/* ORDEN */
.contratoAdhesion section {
  margin-bottom: 15px;
}
.signature-container {
  display: flex;
  flex-direction: row;
}
.signature-body {
  width: 50%;
  padding: 0 15px;
}

.signature-body span:nth-child(2) {
  text-align: center;
  display: block;
  font-size: 12px;
  margin: 5px;
}

.signature-body span:last-child {
  text-align: center;
  display: block;
  font-weight: bold;
  font-size: 14px;
}

.img-container {
  width: 100%;
  height: 200px;
  border: 1px solid #000;
  cursor: pointer;
}

.img-container img {
  width: 100%;
  height: 100%;
}

.button-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin: 100px 0 30px 0;
}

.orden-header-container {
  display: flex;
  flex-direction: column;
}

.detalle-orden-container h3,
.detalle-servicio-container h3 {
  margin-bottom: 10px;
}

.detalle-orden-container,
.detalle-vehiculo-body,
.servicios-orden-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.detalleOrden section {
  margin-bottom: 25px;
}

.noOrden {
  text-align: right;
  margin-bottom: 25px;
}

.orden-header-body {
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
}

.detalle-cliente-container,
.detalle-vehiculo-container,
.servicios-orden-content .group-container {
  width: 50%;
}

.detalle-orden-container .group-container {
  margin-bottom: 5px;
}

.detalle-orden-container .group-container label,
.detalle-servicio-container .group-container label,
.servicios-orden-container .group-container label {
  font-weight: bold;
  margin-right: 5px;
}

.detalle-saldo {
  text-align: right;
  display: block;
  margin-bottom: 50px;
}

ul {
  list-style: none;
}

.contratoAdhesion,
.contract-footer {
  text-align: justify;
}
.msgError {
  text-align: center;
  color: #ff0000;
}

@-webkit-keyframes animatetop {
  from {
    top: -500px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
@keyframes animatetop {
  from {
    top: -500px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}

@media (max-width: 1279px) {
  .contenido-modal {
    min-height: 400px;
    max-width: 100vw;
    border-radius: 6px;
    padding: 0;
    box-shadow: 0px 3px 6px #3d424bb2;
  }
}

@media (max-width: 768px) {
  .movil-header {
    width: 100%;
    height: 60px;
    background-color: #0a4f9c;
    position: relative;
  }

  .movil-header .btn-close {
    position: absolute;
    top: 4px;
    right: 10px;
    filter: brightness(0) invert(1);
  }
  .movil-header .btn-close:hover {
    filter: none;
    background-color: #fff;
  }
  .modal-header {
    margin-bottom: 10px;
  }

  .modal-header span {
    font: normal normal bold 14px/27px Open Sans;
  }

  .contenido-modal {
    height: min-content;
    min-height: 300px;
  }

    .detalleOrden section {
    flex-direction: column;
  }

 .detalle-vehiculo-container {
    margin-top: 35px;
    width: 100%;
  }
}
@media (max-width: 500px) {
  .detalle-vehiculo-body,
  .servicios-orden-content,
  .signature-container {
    flex-direction: column;
  }

  .signature-body {
    width: 100%;
    margin-bottom: 15px;
  }
}
</style>
